import { __assign } from 'tslib';
import { Tooltip as Tooltip$1 } from '@material-ui/core';
import React, { forwardRef } from 'react';
import { useTooltipStyles } from './TooltipStyles.js';

var Tooltip = forwardRef(function (props, ref) {
    var classes = useTooltipStyles(props);
    return React.createElement(Tooltip$1, __assign({ ref: ref, classes: classes }, props));
});
Tooltip.displayName = 'Tooltip';

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map
